module.exports = __webpack_public_path__ + "static/Vishakha-Singh-091b5808cd257b0ed9638a112e2e5a1b.png";